import { METRIC_DISTRIBUTION } from "@/constants";
import { FAMILY } from "@/settings/widgetFamilies";

export default {
  family: [FAMILY.OTHER],
  recommendedFamily: [FAMILY.OTHER],
  name: "",
  title: "Project Recommendations",
  defaultHeight: 8,
  widgetSettings: {
    widget: "DataTable",
  },
  planOnly: true,
  settings: {},
  planSettings: {
    distribution: { default: METRIC_DISTRIBUTION },
    columns: {
      default: [
        {
          title: "Campaign ID",
          value: "campaign_id",
        },
        {
          title: "Business Goal",
          value: "business_goal",
        },
        {
          title: "Plan",
          value: "plan",
        },
        {
          title: "Geography",
          value: "geography",
        },
        {
          title: "Channel",
          value: "channel",
        },
        {
          title: "Campaign KPI",
          value: "campaign_kpi",
        },
        {
          title: "Start Date",
          value: "start_date",
        },
        {
          title: "End Date",
          value: "end_date",
        },
        {
          title: "% of Budget",
          value: "channel_percentage",
        },
        {
          title: "Budget",
          value: "budget",
        },
        {
          title: "CPM",
          value: "cpm",
        },
        {
          title: "Impressions",
          value: "impressions",
        },
      ],
    },
  },
};
